'use strict';

export default function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    title: {text: '1週間の電力消費実績'},
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        format: '{value:%m月%d日}',
        formatter: function () {
          let style = '';
          let day = scope.$filter('dayFilter')(this.value);
          if(day === '日') {
            style = 'color: #ff3131';
          } else if(day === '土') {
            style = 'color: #3737ff';
          }

          return `<span style="${style}">${scope.$filter('date')(this.value, 'MM月dd日')} (${day})</span>`;
        }
      },
      max: 6
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        for (let point of this.points) {
          tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
          tip_format += point.y + " kWh";
          tip_format += "</span>";
        }

        return tip_format;
      }
    },
    plotOptions: {
      column: {grouping: false},
      series: {
        events: {
          click: function(event) {
            scope.$state.go(
              'main.demand_report_show.detail',
              { id: scope.id, type: 'active', term: 'daily', target: event.point.date },
              { reload: true }
            );
          }
        },
        cursor: 'pointer'
      }
    },
    series: []
  };
}



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/active/weekly/compare-graph-weekly.config.js